/**
 * 农历、节气工具
 * 基于 lunar-typescript: https://github.com/6tail/lunar-typescript
 */
import { Solar } from 'lunar-typescript';

export interface LunarInfo {
  lunarDay: string; // 农历日（如"初四"、"廿三"、"四月"——农历月首日返回月名）
  lunarMonth: string; // 完整农历月日（如"四月初四"）
  yearGanZhi: string; // 干支年
  zodiac: string; // 生肖
  solarTerm: string | null; // 当日节气（如"立夏"），无则 null
  isLunarMonthStart: boolean; // 是否农历初一
}

/**
 * 获取某天的农历信息
 * @param date YYYY-MM-DD
 */
export function getLunarInfo(date: string): LunarInfo {
  const parts = date.split('-');
  const year = parseInt(parts[0]!, 10);
  const month = parseInt(parts[1]!, 10);
  const day = parseInt(parts[2]!, 10);

  const solar = Solar.fromYmd(year, month, day);
  const lunar = solar.getLunar();

  const lunarDay = lunar.getDay();
  const isMonthStart = lunarDay === 1;

  return {
    lunarDay: isMonthStart ? lunar.getMonthInChinese() + '月' : lunar.getDayInChinese(),
    lunarMonth: lunar.getMonthInChinese() + '月' + lunar.getDayInChinese(),
    yearGanZhi: lunar.getYearInGanZhi(),
    zodiac: lunar.getYearShengXiao(),
    solarTerm: lunar.getJieQi() || null,
    isLunarMonthStart: isMonthStart,
  };
}
